import './index.scss';
import { useEffect, useRef, useState } from 'react';
import { ISelect } from '../types';
import { limitTextCharacter } from 'src/utils/helpers';
import { FlexColumn, AppLabel, AppText, FlexRow } from 'src/style';
import { DropDown, DropUp, Ellipse, Vector } from 'src/assets/icon';

export const Select = ({
    list,
    Icon,
    name,
    label,
    className,
    labelColor,
    placeholder,
    handleSelect,
    labelSize,
    height,
    defaultValue,
    clearSelect,
    inputClassName,
    selectInputLimit,
}: ISelect) => {
    const [selected, setSelected] = useState("");
    const [showOptions, setShowOptions] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const onSelect = (item: string) => {
        setSelected(item);
        handleSelect(name, item);
        setShowOptions(false);
    };
    const handleClearSelect = () => {
        setSelected("")
    }
    useEffect(() => {
        clearSelect && handleClearSelect()
    },[clearSelect])
    
    useEffect(() => {
        document.addEventListener('click', handleBlur, true);
    }, []);

    const handleBlur = (e: any) => {
        if (!ref?.current?.contains(e.target)) {
            setShowOptions(false);
        };
    };

    useEffect(() => {
        if (!selected && defaultValue && list?.length) {
            const valueIndex = defaultValue - 1 
            const value = list[valueIndex]
            
            setSelected(value);
            if (handleSelect) handleSelect(name, value)
        }
        
    }, [selected, defaultValue, list, handleSelect])

    return (
        <FlexColumn
            alignItems='flex-start'
            bottomMargin='2.4'
            className={`select-container ${className}`}
        >
            <AppLabel
                textSize={labelSize ?? '1.2'}
                fontWeight='600'
                color={labelColor ?? '#374957'}
            >
                {label}
            </AppLabel>

            <FlexRow
                justifyContent='flex-start'
                alignItems='center'
                className={`select-input ${inputClassName}`}
                bgColor='#fff'
                onClick={() => setShowOptions(!showOptions)}
            >
                <div className='input-icon'>{Icon ? Icon : <Vector />}</div>
                <AppText
                    width='100'
                    sizeUnit='%'
                    textSize='1.3'
                    leftPadding='1.6'
                    rightPadding='1.6'
                    fontWeight='500'
                    color={selected ? '#374957' : '#B8B8B8'}
                    cursor='pointer'
                    className='placeholder'
                >
                    {limitTextCharacter(selected, selectInputLimit) || placeholder}
                </AppText>
                <div className='input-icon'>
                    {showOptions ? <DropUp/> : <DropDown />}
                </div>
            </FlexRow>
            {showOptions ?
                <div ref={ref} className='option-container' style={{maxHeight: height }}>
                    {list?.map((item, i) => (
                        <FlexRow
                            key={i}
                            cursor='pointer'
                            leftPadding='1.4'
                            rightPadding='2.4'
                            topPadding='.4'
                            bottomPadding='.4'
                            bottomMargin='.3'
                            hoverBgColor='#b8b8b833'
                            bgColor={selected === item ? '#b8b8b833' : '' }
                            onClick={() => onSelect(item)}
                        >
                            <div className='input-icon'><Ellipse /></div>
                            <AppText
                                width='90'
                                sizeUnit='%'
                                textSize='1.3'
                                leftPadding='1.6'
                                rightPadding='1.6'
                                fontWeight='500'
                                cursor='pointer'
                                color={'#374957'}
                                className='option-text'
                            >
                                {item}
                            </AppText>
                        </FlexRow>
                    ))}
                </div> : null}
        </FlexColumn>
    )
}
